var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"onTheLand",style:({left:this.rleft,width:this.rwidth,height:this.rheight,bottom:this.rbottom}),attrs:{"id":"spine"}})}
var staticRenderFns = []

export { render, staticRenderFns }